/**
 * 批量上传创意监测链接
 */
import { Component, input, output } from '@angular/core';
import {
  BatchUploadConfig,
  BatchUploadModalComponent,
} from '@shared/components/batch-upload-modal/batch-upload-modal.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-batch-upload-monitor',
  imports: [SharedModule, BatchUploadModalComponent],
  template: `
    <app-batch-upload-modal
      [isVisible]="isVisible()"
      [config]="uploadConfig"
      (isVisibleChange)="isVisibleChange.emit($event)"
      (nzOnOk)="nzOnOk()"
    ></app-batch-upload-modal>
  `,
})
export class BatchUploadMonitorComponent {
  // 输入属性
  readonly isVisible = input<boolean>(false);

  // 输出事件
  readonly isVisibleChange = output<boolean>();

  // 上传配置
  uploadConfig: BatchUploadConfig = {
    title: '批量上传创意监测链接',
    templateUrl:
      'https://static-cdn.linkworld.cn/xiaohong/红品智-推广-批量上传创意监测链接模版_2026-11-04.xlsx',
    type: 8,
    description: '1、下载批量上传创意监测链接模板，批量填写监测链接信息',
  };

  nzOnOk() {
    // 手动埋点 红品智-工具-批量上传检测链接
    (window as any)?.lwTrackEvent?.add({
      event_id: 252,
      event_code: 'spotlight-tools-uploadCreateCreativityMonitor',
      event_type: 'upload',
    });
  }
}
